import ContainerDialog from './ContainerDialog'

import Confirm from './Confirm'
import Prompt from './Prompt'
import DialogModal from "./DialogModal";
import DialogAside from "./DialogAside";

const Plugin = {
    install(Vue, options = {}) {
        /**
         * Makes sure that plugin can be installed only once
         */
        if (this.installed) {
            return
        }

        this.installed = true
        this.event = new Vue()
        this.rootInstance = null

        Vue.component('ContainerDialog', ContainerDialog)
        Vue.component('DialogModal', DialogModal)
        Vue.component('DialogAside', DialogAside)

        Vue.prototype.$dialogs = {
            /**
             * Create new component and attach to container
             * Confirmation, prompt, ....
             */
            show(modal, modalProps) {
                return Plugin.rootInstance.show(modal, modalProps)
            },

            /**
             * Show as dynamic component,
             * can be only one instance in time
             */
            showComponent(modal, ...args) {
                return Plugin.rootInstance.showComponent(modal, ...args)
            },

            hide(name, params) {
                Plugin.event.$emit('toggle', name, false, params)
            },
            toggle(name, params) {
                Plugin.event.$emit('toggle', name, undefined, params)
            },
            /*shortcuts*/
            confirm(modalProps) {
                return Plugin.rootInstance.show(Confirm, modalProps)
            },
            confirmDelete(modalProps) {
                let props = {variant: 'danger', okTitle: 'DELETE', ...modalProps}
                return Plugin.rootInstance.show(Confirm, props)
            },
            prompt(...args) {
                return Plugin.rootInstance.show(Prompt, ...args)
            },
        }
    }
}

export default Plugin
